import { ReactNode } from 'react'

import { IconName } from '~/components/Icons'
import { STUDENT_PANEL_VIEW } from '~/types/student'

import PanelMobileNavigation from './PanelMobileNavigation'
import PanelTabs from './PanelTabs/PanelTabs'
import PanelTitle from './PanelTitle'
import { PanelTab, PanelView } from './PanelWrapper.types'

export default function PanelWrapper({
  children,
  disabled,
  tabs,
  title,
  titleIcon,
  view,
}: {
  children: ReactNode
  disabled?: boolean
  tabs: PanelTab[]
  title: string
  titleIcon?: IconName
  view?: PanelView
}): React.ReactElement {
  return (
    <div className="relative isolate max-w-7xl w-full mx-auto h-full">
      <div className="relative z-10">
        <PanelTitle icon={titleIcon} title={title} />
        <div className={`hidden md:block ${disabled ? 'grayscale pointer-events-none' : ''}`}>
          <PanelTabs tabs={tabs} view={view} />
        </div>
        <PanelMobileNavigation isMenuView={view === STUDENT_PANEL_VIEW.MENU} view={view} />
        <div className="mt-4">{children}</div>
      </div>
    </div>
  )
}
